<template>
  <div
    class="operate_box"
    :style="vStyle"
    :class="{ disabledClick: !disabled_set }"
    @click="is_dropdown=false"
    @mouseleave="leave"
  >
    <template v-if="defaultRender">
      <template v-if="isdevice==1">
        <!-- 设备 -->
        <OppleAuth v-if="have_add" code="AddDevice">
          <div
            v-if="have_add"
            class="add_ope oper_button text-button overflow-hidden doc-click" 
            :class="canadd?'canClick':'disabledClick'"
            @click="new_add"
          >
            <i class="el-icon-plus img doc-click" />
            <span class="oper_text doc-click" :title="$t('scene.adddevice')">{{ $t('scene.adddevice') }}</span>
          </div>
        </OppleAuth>
      </template>
      <template v-if="isdevice==2">
        <OppleAuth v-if="have_add" code="AddScene">
          <div
            class="add_ope oper_button text-button"
            :class="canadd?'canClick':'disabledClick'"
          >
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <i class="el-icon-plus img" /><span class="oper_text">{{ $t('scene.add') }}</span>
              </span>
              <el-dropdown-menu
                slot="dropdown"
              >
                <el-dropdown-item
                  @click.native="actionFn(1)"
                >
                  {{ $t('sceneTemplate.templateDefine') }}
                </el-dropdown-item>
                <!-- 灯带展示场景 -->
                <el-dropdown-item
                  v-if="$store.state.lightStripSceneConfig && $store.state.isProfessional"
                  @click.native="actionFn(3)"
                >
                  {{ $t('sceneTemplate.lightTripDefine') }}
                </el-dropdown-item>
                <!-- 图片场景 -->
                <el-dropdown-item
                  v-if="$store.state.picSceneConfig"
                  @click.native="actionFn(4)"
                >
                  <!-- {{ $t('sceneTemplate.tianmu') }} -->
                  {{ $t('sceneTemplate.picScene') }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="actionFn(0)">
                  {{ $t('sceneTemplate.selfDefine') }}
                </el-dropdown-item>
                <el-dropdown-item
                  @click.native="actionFn('copy-scene')"
                >
                  <!-- 复制场景 -->
                  {{ $t('sceneTemplate.copyScene') }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </OppleAuth>
      </template>
      <template v-if="isdevice==3">
        <!-- 自动化 -->
        <OppleAuth v-if="have_add" code="AddAuto">
          <div
            class="add_ope oper_button text-button"
            :class="canadd?'canClick':'disabledClick'"
            @click="new_add"
          >
            <i class="el-icon-plus img" />
            <span class="oper_text">{{ $t('iftttset.add') }}</span>
          </div>
        </OppleAuth>
      </template>

      <div
        class="operate oper_button"
        @click.stop="dropdown_block"
      >
        <template v-if="badgeNum > 0">
          <el-badge
            :value="badgeNum"
            class="item"
          >
            <span
              class="oper_text buttonCss"
              style="display: inline-flex;"
              :title="$t('scene.caozuo')"
            ><i class="icon-3" />{{ $t('scene.caozuo') }} ▼</span>
          </el-badge>
        </template>
        <template v-else>
          <template v-if="isdevice==1">
            <OppleAuth code="MoveDevice,DeleteDevice,SetPowerDevice,SetLightSwitchAndTime,SetPowerUpStatus,SetSenserDelayedTime">
              <span
                class="oper_text buttonCss"
                style="display: inline-flex;"
                :title="$t('scene.caozuo')"
              ><i class="icon-3" />{{ $t('scene.caozuo') }} ▼</span>
            </OppleAuth>
          </template>
          <OppleAuth v-if="isdevice === 2" code="DeleteScene">
            <span
              class="oper_text buttonCss"
              style="display: inline-flex;"
              :title="$t('scene.dele')"
              @click.stop="contorldel"
            >
              <i class="el-icon-delete" />
              &nbsp;{{ $t('scene.dele') }}
            </span>
          </OppleAuth>
          <OppleAuth v-if="isdevice === 3" code="DeleteAuto">
            <span
              class="oper_text buttonCss"
              style="display: inline-flex;"
              :title="$t('scene.dele')"
              @click.stop="contorldel"
            >
              <i class="el-icon-delete" />
              &nbsp;{{ $t('scene.dele') }}
            </span>
          </OppleAuth>
        </template>
        <template v-if="isdevice==1">
          <div
            v-if="is_dropdown"
            class="button_list main3 de_button_list device_opration_box"
          >
            <OppleAuth code="MoveDevice">
              <div
                :class="{'active_bg': true, 'blue_bg': no1Active }"
                @click="remove"
              >
                <slot name="remove" />
              </div>
            </OppleAuth>
            <OppleAuth code="DeleteDevice">
              <div
                :class="{ 'active_bg': true, 'blue_bg': no2Active }"
                @click="dele"
              >
                {{ $t('scene.dele') }}
              </div>
            </OppleAuth>
            <div class="batch_trigger">
              <slot name="setBatchConfig" />
              <div class="install_batch_option" :class="$store.state.lang === 'zh-cn'?'batch_trigger_zh':''">
                <OppleAuth code="SetPowerDevice" :force-show="$store.state.isPassPermission">
                  <div
                    :class="{ 'active_bg': true, 'blue_bg': no3Active }"
                    @click="setpower"
                  >
                    {{ $t('scene.power') }}
                  </div>
                </OppleAuth>
                <OppleAuth code="SetLightSwitchAndTime" :force-show="$store.state.isPassPermission">
                  <div
                    :class="{ 'active_bg': true, 'blue_bg': is_setLampGradual }"
                    @click="setLampGradual"
                  >
                    {{ $t('scene.lampGradual') }}
                  </div>
                </OppleAuth>
                <div
                  v-if="$store.state.huaweiConfig"
                  :class="{ 'active_bg': true, 'blue_bg': is_setLinkagePanel }"
                  @click="setLinkagePanel"
                >
                  {{ $t('scene.lampLinkagePanel') }}
                </div>
                <OppleAuth code="SetSenserDelayedTime" :force-show="$store.state.isPassPermission">
                  <div
                    :class="{ 'active_bg': true, 'blue_bg': is_setSensorExtTime }"
                    @click="setSensorExtTime"
                  >
                    {{ $t('scene.sensorExtTime') }}
                  </div>
                </OppleAuth>
                <div
                  :class="{ 'active_bg': true, 'blue_bg': is_setBatchReset }"
                  @click="setBatchReset"
                >
                  {{ $t('scene.batchReset') }}
                </div>
                <OppleAuth code="SetPowerUpStatus">
                  <div
                    :class="{ 'active_bg': true, 'blue_bg': is_setBatchConfigurePowerOnState }"
                    @click="setBatchConfigurePowerOnState"
                  >
                    {{ $t('scene.batchConfigurePowerOnState') }}
                  </div>
                </OppleAuth>
                <!-- <div
                </OppleAuth> -->
                <div
                  :class="{ 'active_bg': true}"
                  @click="setCLOConfig"
                >
                  {{ $t('scene.batchCLO') }}
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="isdevice==2">
          <div
            v-if="is_dropdown"
            class="button_list main3 de_button_list"
          >
            <div
              :class="{ blue_bg: no1Active }"
              @click="remove"
            >
              <slot name="remove" />
            </div>

            <div
              :class="{ blue_bg: no2Active }"
              @click="dele"
            >
              {{ $t('scene.dele') }}
            </div>
            <div
              :class="{ blue_bg: no3Active }"
              @click="setpower"
            >
              <slot name="setpower" />
            </div>
          </div>
        </template>
        <template v-if="isdevice==3">
          <div
            v-if="is_dropdown"
            class="button_list main3 de_button_list"
          >
            <div
              :class="{ blue_bg: no1Active }"
              @click="remove"
            >
              <slot name="remove" />
            </div>

            <div
              :class="{ blue_bg: no2Active }"
              @click="dele"
            >
              {{ $t('scene.dele') }}
            </div>
            <div
              :class="{ blue_bg: no3Active }"
              @click="setpower"
            >
              <slot name="setpower" />
            </div>
          </div>
        </template>
      </div>
    </template>
    <template v-else-if="is_remove">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="() => cancel(false)"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          @click="removestart"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
                icon="el-icon-place"
              >
                {{ $t('scene.remove') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
              icon="el-icon-place"
            >
              {{ $t('scene.remove') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
            <!-- <span v-if="select">{{ $t('scene.all') }}</span>
						<span v-else>{{ $t('scene.allno') }}</span> -->
          </el-checkbox>
        </div>
      </div>
    </template>
    <template v-else-if="is_del">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="() => cancel(false)"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          :class="isMap?'del_button_map':''"
          @click="delButton"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
                icon="el-icon-delete"
              >
                {{ $t('scene.dele') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
              :class="badgeNum > 0?'':''"
              icon="el-icon-delete"
            >
              {{ $t('scene.dele') }}
            </el-button>
          </template>
        </div>
        <!-- <>  增加自动化删除增加全选功能  -->
        <div
          v-if="isNoAll!=true || isdevice==3 || isdevice==2"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
            <!-- <span v-if="select">{{ $t('scene.all') }}</span>
            <span v-else>{{ $t('scene.allno') }}</span> -->
          </el-checkbox>
        </div>
      </div>
    </template>
    <template v-else-if="is_setpower">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="cancel"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          @click="setpowerstart"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
              >
                {{ $t('scene.yes') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
            >
              {{ $t('scene.yes') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
            <!-- <span v-if="select">{{ $t('scene.all') }}</span>
            <span v-else>{{ $t('scene.allno') }}</span> -->
          </el-checkbox>
        </div>
      </div>
    </template>

    <template v-else-if="is_setPowerOnInitState">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="cancel"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          @click="startPowerOnInitState"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
              >
                {{ $t('scene.yes') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
            >
              {{ $t('scene.yes') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
          </el-checkbox>
        </div>
      </div>
    </template>

    <!-- 设置灯具渐变开关及时长 & 设置灯具联动面板 -->
    <template v-else-if="is_setLampGradual || is_setLinkagePanel">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="cancel"
        >
          {{ $t('scene.cancel') }}
        </div>
        <!-- @click="startLampGradual" -->
        <div
          class="oper_but"
          @click="is_setLampGradual ? startLampGradual() : is_setLinkagePanel ? startLinkagePanel() : () => {}"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
              >
                {{ $t('scene.yes') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
            >
              {{ $t('scene.yes') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-if="is_setLampGradual"
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
          </el-checkbox>
          <!-- 必须首先选一个 才会出现全选 -->
          <div
            v-if="is_setLinkagePanel && gatewayVDeviceId"
            style="cursor: pointer;"
            @click="linkagePanelCheckAll"
          >
            {{ select ? $t('scene.all') : $t('scene.allno') }}
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="is_setSensorExtTime || is_setBatchConfigureCLO">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="cancel"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          @click="is_setSensorExtTime ? startSensorExtTime() : is_setBatchConfigureCLO ? startCLOConfig() : () => {}"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
              >
                {{ $t('scene.yes') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
            >
              {{ $t('scene.yes') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
          </el-checkbox>
        </div>
      </div>
    </template>

    <template v-else-if="is_setBatchReset">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="cancel"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          @click="startBatchReset"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
              >
                {{ $t('scene.yes') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
            >
              {{ $t('scene.yes') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
          </el-checkbox>
        </div>
      </div>
    </template>

    <template v-else-if="is_setBatchConfigurePowerOnState">
      <div class="oper_er">
        <div
          class="back_oper"
          @click="cancel"
        >
          {{ $t('scene.cancel') }}
        </div>
        <div
          class="oper_but"
          @click="startBatchConfigurePowerOnState"
        >
          <template v-if="badgeNum > 0">
            <el-badge
              :value="badgeNum"
              class="item"
            >
              <el-button
                type="text"
                size="small buttonCss"
              >
                {{ $t('scene.yes') }}
              </el-button>
            </el-badge>
          </template>
          <template v-else>
            <el-button
              type="text"
              size="small buttonCss"
            >
              {{ $t('scene.yes') }}
            </el-button>
          </template>
        </div>
        <div
          v-if="isNoAll!=true"
          class="select_but"
        >
          <el-checkbox
            v-model="select"
            @change="checkAll"
          >
            {{ select?$t('scene.all'):$t('scene.allno') }}
          </el-checkbox>
        </div>
      </div>
    </template>

    <el-dialog
      :modal-append-to-body="false"
      class="power_dialog del_dialog"
      :visible.sync="dialogVisible"
      width="650px"
      :before-close="handleClose"
    >
      <div class="del_middle">
        <i
          class="el-icon-close text-button"
          @click="close"
        />
        <i class="icon-41" />
        <p style="line-height: normal;">
          <span style="font-size: 25px;">{{ $t('scene.deltext') }}</span>
          <template v-if="checkedDataGateway!=undefined">
            <span
              v-if="checkedDataGateway==true"
              style="display: block;margin: 5px 0 10px;"
            >{{ $t('scene.gatewayDeleTip') }}</span>
          </template>
          <!-- <template v-else>
            <template v-if="checkedDataGateway!=undefined">
              <span
                v-if="checkedDataGateway==true"
                style="margin-top: 5px;display: block;"
              >{{ $t('scene.gatewayDeleTip') }}</span>
            </template>
          </template> -->
          <span
            slot="footer"
            class="dialog-footer"
          >
            <button
              class="del_button fright"
              @click="del_yes"
            >{{ $t('scene.ok') }}</button>
            <button
              class="del_button fleft"
              @click="del_cancel"
            >{{ $t('scene.cancel') }}</button>
          </span>
        </p>
      </div>
    </el-dialog>
    <el-dialog
      :modal-append-to-body="false"
      class="power_dialog del_dialog"
      :visible.sync="showSetLampGradualDialog"
      width="480px"
      :before-close="handleClose"
    >
      <div class="del_middle device_type">
        <i
          class="el-icon-close text-button"
          @click="closeDialog"
        />
        <div class="title_box">  
          <i class="el-icon-warning" />
          <span>{{ $t('scene.deviceTypes') }}</span>
        </div>
        <div class="type_box">  
          <el-radio
            v-model="deviceType"
            label="64"
          >
            DALI
          </el-radio>
          <el-radio
            v-model="deviceType"
            label="8"
          >
            {{ $t('scene.bluetooth') }} / {{ $t('adddevice.ethernet') }}
          </el-radio>
          <!-- <el-radio
            v-model="deviceType"
            label="8"
          >
            {{ $t('adddevice.ethernet') }}
          </el-radio> -->
        </div>
        <div class="iftttNotice_saveBtns">
          <div
            class="iftttNotice_saveBtns_btn iftttNotice_saveBtns_btn-back"
            @click="closeDialog"
          >
            {{ $t('base.cancel') }}
          </div>
          <div
            class="iftttNotice_saveBtns_btn iftttNotice_saveBtns_btn-save"
            @click="onSaveDeviceByType"
          >
            {{ $t('base.sure') }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<!-- eslint-disable no-lonely-if -->
<script>
import { warning } from '@/assets/js/common.js'
import sleep from '@utils/sleep'
export default {
  /**
   * gatewayVDeviceId: 网关id
   * 
   */
  // eslint-disable-next-line vue/require-prop-types, vue/prop-name-casing
  props: ['badgeNum', 'totalNum', 'have_add', 'disabled_set', 'canadd', 'isarea', 'isdevice', 'iscontrol', 'isNoAll', 'checkedDataGateway', 'checkedData', 'cardlist', 'isRestStyle', 'gatewayVDeviceId','isMap', 'vStyle'],
  data () {
    return {
      no1Active: false, // 移动是否显示
      no2Active: false, // 删除是否显示
      no3Active: false, // 设置最大功率是否显示
      is_dropdown: false, // 是否显示下拉内容
      is_remove: false, // 移动下拉
      is_del: false, // 删除下拉
      is_setpower: false, // 设置最大功率下拉
      is_setPowerOnInitState: false, // 设置灯具上电状态
      is_setLampGradual: false, // 设置灯具渐变开关及时长
      is_setLinkagePanel: false, // 设置灯具联动面板
      is_setSensorExtTime: false, // 设置传感器延长时间
      is_setBatchReset: false, // 设置批量专业复位
      is_setBatchConfigurePowerOnState: false, // 设置批量配置上电状态
      is_setBatchConfigureCLO: false, // 设置批量配置CLO
      dialogVisible: false, // 弹出是否显示
      // checked:false, //是否全选 复选框
      select: false, // 是否全选
      checkedDataSelect: '',
      checkedDataSelectScene: '',
      delDeviceRuleList: [],
      showSetLampGradualDialog:false,//设置弹窗选择设备类型（dali/蓝牙）
      deviceType:'64',
      devicemenue: [
        { id: 2, name: this.$t('adddevice.realgateway'), path: 'findGateway', disable: false },
        { id: 1, name: this.$t('adddevice.realdevice'), path: 'findDevice', disable: false },
        { id: 3, name: this.$t('adddevice.realthirdparty'), path: 'addThirdDevice', disable: false },
        { id: 6, name: this.$t('adddevice.ethernet'), path: 'findEthernet', disable: false }
      ], 
    }
  },
  computed: {
    badgeNums: function () {
      return this.badgeNum
    },
    defaultRender(){
      return (
        !this.is_remove && 
        !this.is_del&&
        !this.is_setpower&&
        !this.is_setPowerOnInitState&&
        !this.is_setLampGradual && 
        !this.is_setLinkagePanel &&
        !this.is_setSensorExtTime&&
        !this.is_setBatchReset&&
        !this.is_setBatchConfigurePowerOnState && 
        !this.is_setBatchConfigureCLO
      )
    }
  },
  watch: {
    disabled_set (param) {
      if (!param) {
        this.cancel()
      }
    },
    badgeNums () {
      if (this.isNoAll !== true) {
        if (this.badgeNum != null && this.totalNum != null) {
          if (this.badgeNum === this.totalNum) {
            this.select = true
          } else {
            this.select = false
          }
        }
      }
    },
  },
  methods: {
    closeDialog(){
      this.showSetLampGradualDialog = false
    },
    onSaveDeviceByType(){
      this.showSetLampGradualDialog = false
      this.resetShowStyle()
      this.is_setLampGradual = true
      this.$emit('setLampGradual',{deviceType:this.deviceType})
    },
    actionFn (v) {
      this.$emit('show-template', v);
    },

    /** 统一重置展示样式 */
    resetShowStyle () {
      this.no1Active = false
      this.no2Active = false
      this.no3Active = false
      this.is_remove = false
      this.is_del = false
      this.is_setpower = false
      this.is_setPowerOnInitState = false
      this.is_setLampGradual = false
      this.is_setLinkagePanel = false
      this.is_setSensorExtTime = false
      this.is_setBatchReset = false
      this.is_setBatchConfigurePowerOnState = false
      this.is_setBatchConfigureCLO = false
    },

    // 设置灯具上电状态
    setPowerOnInitState () {
      this.resetShowStyle()
      this.is_setPowerOnInitState = true
      this.$emit('setPowerOnInitState')
    },
    // 设置灯具渐变开关及时长
    setLampGradual () {
     //设置弹窗选择设备类型（dali/蓝牙）
     this.showSetLampGradualDialog = true
    },
    // 设置灯具联动面板
    setLinkagePanel () {
      this.resetShowStyle()
      this.is_setLinkagePanel = true
      this.$emit('setLinkagePanel')
    },
    // 设置传感器延长时间
    setSensorExtTime () {
      this.resetShowStyle()
      this.is_setSensorExtTime = true
      this.$emit('setSensorExtTime')
    },
    //专业复位
    setBatchReset () {
      this.resetShowStyle()
      this.is_setBatchReset = true
      this.$emit('setBatchReset')
    },
    //批量上电状态
    setBatchConfigurePowerOnState () {
      this.resetShowStyle()
      this.is_setBatchConfigurePowerOnState = true
      this.$emit('setBatchConfigurePowerOnState')
    },
    //批量配置CLO
    setCLOConfig(){
      this.is_setBatchConfigureCLO = true
      this.$emit('setCLOConfig')
    },
    /* 关闭弹窗
    */
    close () {
      this.dialogVisible = false
    },
    /* 移动
    */
    remove () {
      this.resetShowStyle()
      this.no1Active = true
      this.is_remove = true
      this.$emit('remove')
    },
    /* 判断是否有设备选中
    */
    isSelect () { // 判断是否有设备选中
      if (this.badgeNum < 1) {
        if (this.isdevice === 3) {
          warning(this, this.$t('ifttt.selectIFTTT'))
        } else if (this.isdevice === 2) {
          warning(this, this.$t('scene.selectScence'))
        } else {
          warning(this, this.$t('install.devicecounterror'))
        }
        return false
      }
      return true
    },
    /* 点击删除
    */
    delButton () {
      if (this.isSelect()) {
        this.delDeviceRuleOf()
      }
    },
    delDeviceRuleOf () {
      this.dialogVisible = true
    },
    /* 关闭弹窗
    */
    handleClose (done) {
      done()
    },
    /* 确认删除 上抛给调用页面
    */
    del_yes () {
      this.dialogVisible = false
      this.$emit('sureDel')
    },
    /* 取消 关闭弹窗
    */
    del_cancel () {
      this.dialogVisible = false
    },
    /* 点击删除
    */
    dele () {
      this.resetShowStyle()
      this.no2Active = true
      this.is_del = true
      this.$emit('dele')
    },
    /* 点击设置最大功率
    */
    setpower () {
      this.resetShowStyle()
      this.no3Active = true
      this.is_setpower = true
      this.$emit('setpower')
    },
    /* 下拉显示
    */
    dropdown_block () {
      if (this.disabled_set) {
        this.is_dropdown = !this.is_dropdown
      }
    },
    /* 删除
    */
    contorldel () {
      if (this.iscontrol) {
        this.dele()
      } else {
        warning(this, this.$t('scene.areawarn'))
      }
    },
    /* 取消
    */
    cancel (isRequestDevice = true) {
      this.resetShowStyle()
      this.select = false
      this.$emit('cancel', isRequestDevice)
    },
    /* 新增
    */
    new_add () {
      if (this.canadd) {
        this.$emit('new_add')
      } else if (this.isarea) {
          warning(this, this.$t('scene.roomwarn'))
        }
    },
    /* 设置最大功率 传值回调用页
    */
    startPowerOnInitState () {
      if (this.disabled_set) {
        this.$emit('startPowerOnInitState')
      }
    },
    /* 设置最大功率 传值回调用页
    */
    startLampGradual () {
      if (this.disabled_set) {
        this.$emit('startLampGradual')
      }
    },

    /** 设置最大功率 传值回调用页 */
    startLinkagePanel () {
      console.log('click')
      if (this.disabled_set) {
        this.$emit('startLinkagePanel')
      }
    },

    /* 设置最大功率 传值回调用页
    */
    startSensorExtTime () {
      if (this.disabled_set) {
        this.$emit('startSensorExtTime')
      }
    },
    /*
    */
    startBatchReset () {
      if (this.disabled_set) {
        this.$emit('startBatchReset')
      }
    },
    /*
    */
    startBatchConfigurePowerOnState () {
      if (this.disabled_set) {
        this.$emit('startBatchConfigurePowerOnState')
      }
    },
    startCLOConfig () {
      if (this.disabled_set) {
        this.$emit('startCLOConfig')
      }
    },
    /* 设置最大功率 传值回调用页
    */
    setpowerstart () {
      if (this.disabled_set) {
        this.$emit('setpowerstart')
      }
    },
    /* 移动 传值回调用页
    */
    removestart () {
      if (this.disabled_set) {
        this.$emit('removestart')
      }
    },
    /* 全选 反选
    */
    checkAll (e) {
      if (e) {
        this.select = true
      } else {
        this.select = false
      }
      this.$emit('checkAll', e)
      
    },
    /** 点击全选(选中同网关下的所有设备)/反选 (联动面板需求) */
    async linkagePanelCheckAll () {
      if(this.select) {
        // 已全选, 可以点击全不选
        this.$emit('checkAll', false)
        await sleep(100)
        this.select = false
      } else {
        // 未全选, 有网关id的情况下才可点击全选
        if(this.gatewayVDeviceId) {
          this.$emit('checkAll', true)
          await sleep(100)
          this.select = true
        } else {
          console.log('请先选中一个设备, 才能全选对应网关下的其他设备')
        }
      }
    },
    /** 更新 select 的值, 全选/全不选按钮 */
    async updateSelect (bool) {
      await sleep(100)
      this.select = bool
    },
    /* 鼠标移开下拉 隐藏
    */
    leave () {
      this.is_dropdown = false
      // this.cancel()
    },
    /* 未使用
    */
    addleave () {
      this.$emit('leaveadd')
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
/* 设备安装，照明控制，自动化操作 */
.operate_box .operate:hover {
    color: $color5;
}
.add_ifttt div{
  padding-right: 15px;
}
.operate_box{
  font-size: 14px;
    color: #525252;
    width: 100%;
    float: left;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;

  .oper_er{
    float: left;
    width: 100%;
    .back_oper{
      display: inline-block;
      float: right;
    }
    .oper_but{
      display: inline-block;
      float: right;
      margin-right: 20px;
      margin-left: 10px;
    }
    .select_but{
      display: inline-block;
      float: left;
      margin-right: 10px;
    }
  }
  .oper_button{
    position: relative;
  }
  .operate{
    display: inline-block;
    float: right;
    margin-right: 5px;
    img{
      vertical-align: middle;
    }
    .icon-3{
      font-weight: bold;
      margin-right: 5px;
    }
  }
  .overflow-hidden{
      width: 90px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  .add_ope{
    display: block;
    border-radius: 2px;
    // float: right;
    height: 28px;
    line-height: 28px;
    background: #0046aa;
    color: #fff;
    padding: 0 10px;
    .el-icon-plus{
      font-size: 12px;
      font-weight: bold;
    }
    .oper_text{
      color: #fff;
    }
    .el-icon-plus{
      color: #fff;
    }
  }
}
.disabledClick{
  // pointer-events: none;
  color: #a8a8a8;
  .operate:hover {
    color:#a8a8a8;
  }
}
.operate_box .buttonCss{
  border: solid 1px #0046aa;
  color: #0046AA;
  padding: 0 10px;
  height: 28px;
  line-height: 28px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}
.operate_box .item>.buttonCss,.operate_box .oper_but>button.buttonCss {
  display: inline-flex;
}
.operate_box>.buttonCss{
  margin: 17px 0;
}
.button_list {
  top: 84% !important;
  .batch_trigger{
    position: relative;
  }
  .install_batch_option{
    display: none;
    top: -78px;
    right: 137px;
    padding-right: 6px;
    margin-right: 10px;
    white-space: wrap;
    background-color: #fff;
    position: absolute;
    box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.3);
  }
  .batch_trigger:hover .install_batch_option{
    display: block;
  }
  .batch_trigger_zh{
    top: -78px;
    right: 142px;
  }
  .active_bg:hover{
    background-color: #E0E9F8;
  }
}
.operate .device_opration_box{
  width: fit-content;
  min-width: 150px!important;
}
.install_batch_modal{
  line-height: 20px;
}
.del_middle_scene{
  color: #636367;
  width: max-content;
  float: left;
  padding: 0 20px;
  height: 100%;
  line-height: 25px;
  border-radius: 15px;
  font-weight: bold;
  cursor: pointer;
}
.del_middle_scene_select{
  background: #439AF3;
  color: white;
}
.dialog-footer{
  margin-top: 20px;
}
.device_type{
  width: 480px;
  height: 192px;
  font-size: 18px;
  .title_box{
    padding-left: 36px;
    line-height: 22px;
    i{
      font-size: 22px;
      color: rgba(0,0,0,0.65);
      display: inline-block;
      margin-right: 10px;
    }
  }
  .type_box{
    padding-left: 72px;
    line-height: 48px;
  }
}
.iftttNotice_saveBtns {
  display: flex;
  padding: 20px 36px;
  justify-content: flex-end;
  background: white;
  margin: 0px;
  z-index: 1001;

  .iftttNotice_saveBtns_btn {
    width: 120px;
    padding: 9px 0;
    border: solid 1px #a6a6a6;
    border-radius: 3px;
    line-height: 22px;
    background: #fff;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    
    &-save {
      color: #fff;
      margin-left: 6px;
      background-color: #2145A4;
      border-color: #2145A4;
    }

    &-back {
      color: #525252;
      border-color: #dfdfdf;
    }
  }
}
.del_button_map ::v-deep .el-badge__content.is-fixed{
  top:0px !important
}

</style>
